import { EHealthProceduresTypes } from '~/interfaces'

export const filterHealthProceduresTypesGeneral = [
  {
    text: 'Cirurgias',
    type: [EHealthProceduresTypes.SURGERY]
  },
  {
    text: 'Exames Anatomopatológicos',
    type: [EHealthProceduresTypes.ANATOMOPATHOLOGICAL_TEST]
  },
  {
    text: 'Exames de Imagem',
    type: [
      EHealthProceduresTypes.IMAGING_TEST,
      EHealthProceduresTypes.ECHOCARDIOGRAM_TEST,
      EHealthProceduresTypes.RADIOLOGY_IMAGING_TEST,
      EHealthProceduresTypes.MATERNAL_INFANT_IMAGING_TEST
    ]
  },
  {
    text: 'Exames Laboratoriais',
    type: [EHealthProceduresTypes.LABORATORY_TEST]
  },
  {
    text: 'Notas Médicas',
    type: [EHealthProceduresTypes.MEDICAL_NOTE]
  },
  {
    text: 'Internações',
    type: [EHealthProceduresTypes.ADMISSION]
  }
]

export const filterHealthProceduresTypesMaternalInfant = [
  {
    text: 'Cirurgias',
    type: [EHealthProceduresTypes.SURGERY]
  },
  {
    text: 'Consultas',
    type: [EHealthProceduresTypes.MEDICAL_APPOINTMENT]
  },
  {
    text: 'Exames Anatomopatológicos',
    type: [EHealthProceduresTypes.ANATOMOPATHOLOGICAL_TEST]
  },
  {
    text: 'Exames de Imagem',
    type: [
      EHealthProceduresTypes.IMAGING_TEST,
      EHealthProceduresTypes.ECHOCARDIOGRAM_TEST,
      EHealthProceduresTypes.RADIOLOGY_IMAGING_TEST,
      EHealthProceduresTypes.MATERNAL_INFANT_IMAGING_TEST
    ]
  },
  {
    text: 'Exames Laboratoriais',
    type: [EHealthProceduresTypes.LABORATORY_TEST]
  },
  {
    text: 'Vacinas',
    type: [EHealthProceduresTypes.VACCINE]
  },
  {
    text: 'Notas Médicas',
    type: [EHealthProceduresTypes.MEDICAL_NOTE]
  },
  {
    text: 'Internações',
    type: [EHealthProceduresTypes.ADMISSION]
  }
]

export const filterHealthProceduresTypesRadiology = [
  {
    text: 'Cirurgias',
    type: [EHealthProceduresTypes.SURGERY]
  },
  {
    text: 'Exames Anatomopatológicos',
    type: [EHealthProceduresTypes.ANATOMOPATHOLOGICAL_TEST]
  },
  {
    text: 'Exames de Imagem',
    type: [
      EHealthProceduresTypes.IMAGING_TEST,
      EHealthProceduresTypes.ECHOCARDIOGRAM_TEST,
      EHealthProceduresTypes.RADIOLOGY_IMAGING_TEST,
      EHealthProceduresTypes.MATERNAL_INFANT_IMAGING_TEST
    ],
    subTypes: [
      {
        text: 'Abdome',
        type: ['ABDOMEN ']
      },
      {
        text: 'Cabeça-pescoço',
        type: ['HEAD_AND_NECK']
      },
      {
        text: 'Músculo esquelético',
        type: ['SKELETAL_MUSCLE']
      },
      {
        text: 'Neuro',
        type: ['NEURO ']
      },
      {
        text: 'Tórax',
        type: ['CHEST']
      },
      {
        text: 'Ultrassonografia',
        type: ['ULTRASOUND']
      }
    ]
  },
  {
    text: 'Exames Laboratoriais',
    type: [EHealthProceduresTypes.LABORATORY_TEST]
  },
  {
    text: 'Notas Médicas',
    type: [EHealthProceduresTypes.MEDICAL_NOTE]
  },
  {
    text: 'Internações',
    type: [EHealthProceduresTypes.ADMISSION]
  }
]

export const filterHealthProceduresTypesOncology = [
  {
    text: 'Notas Médicas',
    type: [EHealthProceduresTypes.MEDICAL_NOTE]
  },
  {
    text: 'Exames de Imagem de Mama',
    type: [EHealthProceduresTypes.EVALUATION_BREAST_IMAGING_TEST]
  },
  {
    text: 'Exames Laboratoriais',
    type: [EHealthProceduresTypes.LABORATORY_TEST]
  },
  {
    text: 'Cirurgias',
    type: [EHealthProceduresTypes.SURGERY]
  },
  {
    text: 'Diagnósticos',
    type: [
      EHealthProceduresTypes.DIAGNOSIS,
      EHealthProceduresTypes.DIAGNOSIS_BIOPSY,
      EHealthProceduresTypes.ANATOMOPATHOLOGICAL_TEST,
      EHealthProceduresTypes.DIAGNOSIS_ANATOMOPATHOLOGICAL_TEST
    ]
  }
]
